// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v3.21.12
// source: processinput.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "login";

export interface ProcessInputRequest {
  textArea: string;
  fileBytes: Uint8Array[];
  fileNames: string[];
  /** True if this is a retry after insufficient data */
  isRetry: boolean;
}

export interface ProcessInputResponse {
  caseJson: string;
  containsPii: boolean;
  invalidInput: boolean;
  insufficientData: boolean;
  /** List of missing factor names when insufficient_data is true */
  missingFactors: string[];
}

function createBaseProcessInputRequest(): ProcessInputRequest {
  return { textArea: "", fileBytes: [], fileNames: [], isRetry: false };
}

export const ProcessInputRequest: MessageFns<ProcessInputRequest> = {
  encode(message: ProcessInputRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.textArea !== "") {
      writer.uint32(10).string(message.textArea);
    }
    for (const v of message.fileBytes) {
      writer.uint32(18).bytes(v!);
    }
    for (const v of message.fileNames) {
      writer.uint32(26).string(v!);
    }
    if (message.isRetry !== false) {
      writer.uint32(32).bool(message.isRetry);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProcessInputRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcessInputRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.textArea = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fileBytes.push(reader.bytes());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fileNames.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isRetry = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProcessInputRequest {
    return {
      textArea: isSet(object.textArea)
        ? globalThis.String(object.textArea)
        : isSet(object.text_area)
        ? globalThis.String(object.text_area)
        : "",
      fileBytes: globalThis.Array.isArray(object?.fileBytes)
        ? object.fileBytes.map((e: any) => bytesFromBase64(e))
        : globalThis.Array.isArray(object?.file_bytes)
        ? object.file_bytes.map((e: any) => bytesFromBase64(e))
        : [],
      fileNames: globalThis.Array.isArray(object?.fileNames)
        ? object.fileNames.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.file_names)
        ? object.file_names.map((e: any) => globalThis.String(e))
        : [],
      isRetry: isSet(object.isRetry)
        ? globalThis.Boolean(object.isRetry)
        : isSet(object.is_retry)
        ? globalThis.Boolean(object.is_retry)
        : false,
    };
  },

  toJSON(message: ProcessInputRequest): unknown {
    const obj: any = {};
    if (message.textArea !== "") {
      obj.textArea = message.textArea;
    }
    if (message.fileBytes?.length) {
      obj.fileBytes = message.fileBytes.map((e) => base64FromBytes(e));
    }
    if (message.fileNames?.length) {
      obj.fileNames = message.fileNames;
    }
    if (message.isRetry !== false) {
      obj.isRetry = message.isRetry;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProcessInputRequest>, I>>(base?: I): ProcessInputRequest {
    return ProcessInputRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProcessInputRequest>, I>>(object: I): ProcessInputRequest {
    const message = createBaseProcessInputRequest();
    message.textArea = object.textArea ?? "";
    message.fileBytes = object.fileBytes?.map((e) => e) || [];
    message.fileNames = object.fileNames?.map((e) => e) || [];
    message.isRetry = object.isRetry ?? false;
    return message;
  },
};

function createBaseProcessInputResponse(): ProcessInputResponse {
  return { caseJson: "", containsPii: false, invalidInput: false, insufficientData: false, missingFactors: [] };
}

export const ProcessInputResponse: MessageFns<ProcessInputResponse> = {
  encode(message: ProcessInputResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.caseJson !== "") {
      writer.uint32(10).string(message.caseJson);
    }
    if (message.containsPii !== false) {
      writer.uint32(16).bool(message.containsPii);
    }
    if (message.invalidInput !== false) {
      writer.uint32(24).bool(message.invalidInput);
    }
    if (message.insufficientData !== false) {
      writer.uint32(32).bool(message.insufficientData);
    }
    for (const v of message.missingFactors) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProcessInputResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcessInputResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.caseJson = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.containsPii = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.invalidInput = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.insufficientData = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.missingFactors.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProcessInputResponse {
    return {
      caseJson: isSet(object.caseJson)
        ? globalThis.String(object.caseJson)
        : isSet(object.case_json)
        ? globalThis.String(object.case_json)
        : "",
      containsPii: isSet(object.containsPii)
        ? globalThis.Boolean(object.containsPii)
        : isSet(object.contains_pii)
        ? globalThis.Boolean(object.contains_pii)
        : false,
      invalidInput: isSet(object.invalidInput)
        ? globalThis.Boolean(object.invalidInput)
        : isSet(object.invalid_input)
        ? globalThis.Boolean(object.invalid_input)
        : false,
      insufficientData: isSet(object.insufficientData)
        ? globalThis.Boolean(object.insufficientData)
        : isSet(object.insufficient_data)
        ? globalThis.Boolean(object.insufficient_data)
        : false,
      missingFactors: globalThis.Array.isArray(object?.missingFactors)
        ? object.missingFactors.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.missing_factors)
        ? object.missing_factors.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ProcessInputResponse): unknown {
    const obj: any = {};
    if (message.caseJson !== "") {
      obj.caseJson = message.caseJson;
    }
    if (message.containsPii !== false) {
      obj.containsPii = message.containsPii;
    }
    if (message.invalidInput !== false) {
      obj.invalidInput = message.invalidInput;
    }
    if (message.insufficientData !== false) {
      obj.insufficientData = message.insufficientData;
    }
    if (message.missingFactors?.length) {
      obj.missingFactors = message.missingFactors;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProcessInputResponse>, I>>(base?: I): ProcessInputResponse {
    return ProcessInputResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProcessInputResponse>, I>>(object: I): ProcessInputResponse {
    const message = createBaseProcessInputResponse();
    message.caseJson = object.caseJson ?? "";
    message.containsPii = object.containsPii ?? false;
    message.invalidInput = object.invalidInput ?? false;
    message.insufficientData = object.insufficientData ?? false;
    message.missingFactors = object.missingFactors?.map((e) => e) || [];
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
